import Image from 'next/image';

import { JumboGetintegrationsIntegrationResponse } from '@explorer/open-api-client';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useIntl } from 'react-intl';

import { Box, Stack, Typography } from '@crucible-risk/security-applications';

interface IntegrationStatusProps {
  integration?: JumboGetintegrationsIntegrationResponse;
  integrationName: string;
  integrationLogo: string;
  nameTranslationId: string;
  connectedTranslationId: string;
  notConnectedTranslationId: string;
  isDisabled?: boolean;
}

export const IntegrationStatus = ({
  integration,
  integrationName,
  integrationLogo,
  nameTranslationId,
  connectedTranslationId,
  notConnectedTranslationId,
  isDisabled = false,
}: IntegrationStatusProps) => {
  const intl = useIntl();

  const isConnected = integration?.isConnected ?? false;

  return (
    <Stack
      direction="row"
      sx={{
        p: 2,
        backgroundColor: 'grey.900',
        opacity: isDisabled ? 0.5 : 1,
      }}
      alignItems="center"
    >
      <Stack flex={1} direction="row" gap={1} alignItems="center">
        <Box
          sx={{
            p: 1,
            pb: 0,
            bgcolor: 'white',
            borderRadius: 3,
            borderColor: 'grey.700',
            borderWidth: '1px',
            borderStyle: 'solid',
          }}
        >
          <Image
            src={integrationLogo}
            alt={integrationName}
            width={32}
            height={32}
            unoptimized
          />
        </Box>
        <Stack>
          <Typography color={isDisabled ? 'text.disabled' : 'text.primary'}>
            {intl.formatMessage({
              id: nameTranslationId,
            })}
          </Typography>
        </Stack>
      </Stack>
      <Stack>
        <Stack direction="row" gap={1} alignItems="center">
          {isConnected ? (
            <>
              <CheckCircleIcon color="success" />
              <Typography
                variant="body1"
                color={isDisabled ? 'text.disabled' : 'text.primary'}
              >
                {intl.formatMessage({
                  id: connectedTranslationId,
                })}
              </Typography>
            </>
          ) : (
            <>
              <CancelIcon color={isDisabled ? 'disabled' : 'error'} />
              <Typography
                variant="body1"
                color={isDisabled ? 'text.disabled' : 'text.primary'}
              >
                {intl.formatMessage({
                  id: notConnectedTranslationId,
                })}
              </Typography>
            </>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};
